<latam-layout>
  <!-- <div [@routeAnimations]="getRouteAnimationData()"> -->
  <router-outlet></router-outlet>
  <!-- </div> -->
</latam-layout>

<ng-template #timeoutTemplate let-timeoutDate>
  <p class="colon" i18n
    >Are you still there? If not your session will be ended in approximately</p
  >
  <div>{{ timeoutDate | dfnsFormatDistanceToNow }}</div>
</ng-template>

<la-dev-panel *laIfDev></la-dev-panel>
